import React, { useCallback, useMemo } from 'react';
import { AutocompleteDropdown, Box } from '@common-fe/common-fe';

import { OptionKey } from '@/common/types';
import {
  LOCKBOX_TYPES_OPTIONS,
  LockboxActiveType,
  LockboxType,
  LockboxValidationError,
  lockboxValidationErrorTitle,
  PAYMENT_LOCKBOX_TYPES,
} from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const lockboxTypeOptions = LOCKBOX_TYPES_OPTIONS.filter((option) => option.key !== LockboxType.UNKNOWN);

const LockboxDocumentTypeInput = () => {
  const { editableLockbox, originalLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();

  const handleUpdateLockboxType = useCallback((lockboxType: OptionKey) => {
    setEditableLockbox({
      lockboxType: lockboxType as LockboxType,
    });
  }, [setEditableLockbox]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.TYPE_REQUIRED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  const options = useMemo(() => {
    if (originalLockbox?.archiveType === LockboxActiveType.PAYMENT) {
      return lockboxTypeOptions.filter((option) => PAYMENT_LOCKBOX_TYPES.includes(option.key as LockboxType));
    }
  
    if (originalLockbox?.archiveType === LockboxActiveType.NOPAYMENT) {
      return lockboxTypeOptions.filter((option) =>
        !PAYMENT_LOCKBOX_TYPES.includes(option.key as LockboxType)
      );
    }
  
    return lockboxTypeOptions;
  }, [originalLockbox]);

  return (
    <Box>
      <AutocompleteDropdown
        testId="lockbox-type"
        name="lockboxTypeInput"
        value={editableLockbox?.lockboxType}
        defaultValue={editableLockbox?.lockboxType}
        onChange={handleUpdateLockboxType}
        options={options}
        {...errorType ? { errorText: lockboxValidationErrorTitle?.[errorType] } : {}}
        placeholder="Document Type"
        disableFiltering
        ellipsisMode
        isSmall
        isBold
      />
    </Box>
  );
};

export default LockboxDocumentTypeInput;
